/** Abort is mounted only while the server would still accept it. */
import {useLiveGame} from '@/Store/liveGameStore';
import {selectShowAbort} from '@/Store/liveGame/selectors';

export type AbortTileModel = {
  showAbort: boolean;
  onPress: () => void;
};

export function useAbortTileModel(): AbortTileModel {
  return {
    showAbort: useLiveGame(selectShowAbort),
    onPress: useLiveGame(s => s.actions.abort),
  };
}
